import { createContext } from "react";
import { KeycloakTokens } from "types/globals";
import { useAccurateContext } from "../utils/useAccurateContext";

interface AuthContextI {
  auth: KeycloakTokens | null;
}

export const AuthContext = createContext<AuthContextI | null>(null);
export const useAuthContext = () => useAccurateContext(AuthContext);
